package com.siriusxm.cmc.smithy

import androidx.compose.runtime.Composable
import androidx.compose.runtime.key
import androidx.compose.runtime.remember
import org.intellij.markdown.flavours.gfm.GFMFlavourDescriptor
import org.intellij.markdown.html.HtmlGenerator
import org.intellij.markdown.parser.MarkdownParser
import org.jetbrains.compose.web.dom.Div

/**
 * Renders markdown text as HTML within a Div element.
 * Uses the JetBrains markdown library to parse GitHub Flavored Markdown (GFM) and generate HTML.
 * Supports tables, strikethrough, autolinks, and task lists.
 *
 * Note: Uses key() to force element recreation when markdown changes,
 * ensuring the ref block runs again to update innerHTML.
 *
 * @param markdown The markdown string to render
 */
@Composable
fun MarkdownText(markdown: String) {
    val html = remember(markdown) {
        val flavour = GFMFlavourDescriptor()
        val parser = MarkdownParser(flavour)
        val tree = parser.buildMarkdownTreeFromString(markdown)
        HtmlGenerator(markdown, tree, flavour).generateHtml()
    }
    key(markdown) {
        Div({
            ref { element ->
                element.innerHTML = html
                onDispose { }
            }
        })
    }
}
